import Component from '../app/component'

export default class ContactsComponent extends Component {
  constructor(el) {
    super(el)
    this.data = {
      errors: []
    }
  }

  init () {
    this.formSetup()
  }

  formSetup() {
    if (this.refs.form) {
      this.refs.form.addEventListener('click', () => {
        console.log('QUESTO CLICK')
        if (this.refs.fieldSecret) {
          this.refs.fieldSecret.value = '%'
        }
      })
      this.refs.form.addEventListener('submit', e => {
        if (this.formValidation()) {
          return
        }
        e.preventDefault()
      })
    }
  }

  formValidation() {
    const errors = []

    if (this.refs.fieldName && !this.refs.fieldName.value) {
      errors.push('fieldName')
    }
    if (this.refs.fieldEmail && !this.refs.fieldEmail.value) {
      errors.push('fieldEmail')
    }
    if (this.refs.fieldMessage && !this.refs.fieldMessage.value) {
      errors.push('fieldMessage')
    }
    if (this.refs.fieldPrivacy && !this.refs.fieldPrivacy.checked) {
      errors.push('fieldPrivacy')
    }

    this.data.errors = errors

    return this.data.errors.length === 0
  }

  watchErrors(value) {
    ['fieldName', 'fieldEmail', 'fieldMessage', 'fieldPrivacy'].forEach(key => {
      if (this.refs[key]) {
        this.refs[key].parentNode.classList[value.includes(key) ? 'add' : 'remove']('ui-form-field--error')
      }
    })
  }
}
